import { lazy } from "react";

// ─── Public / Guest Pages ────────────────────────────────────────────────────

export const ResetPasswordPage = lazy(() =>
	import("../pages/reset-password").then((m) => ({
		default: m.ResetPasswordPage,
	})),
);
export const VerifyEmailPage = lazy(() =>
	import("../pages/verify-email").then((m) => ({
		default: m.VerifyEmailPage,
	})),
);

// ─── Pro Pages ────────────────────────────────────────────────────────────

export const DashboardPage = lazy(() =>
	import("../pages/dashboard").then((m) => ({ default: m.DashboardPage })),
);
export const ProfilePage = lazy(() =>
	import("../pages/profile").then((m) => ({ default: m.ProfilePage })),
);
export const ProjectsPage = lazy(() =>
	import("../pages/projects").then((m) => ({ default: m.ProjectsPage })),
);
export const ProjectDetailsPage = lazy(() =>
	import("../pages/project-details").then((m) => ({
		default: m.ProjectDetailsPage,
	})),
);
export const TeamPage = lazy(() =>
	import("../pages/team").then((m) => ({ default: m.TeamPage })),
);
export const AcceptInvitationPage = lazy(() =>
	import("../pages/accept-invitation").then((m) => ({
		default: m.AcceptInvitationPage,
	})),
);
export const InsightsPage = lazy(() =>
	import("../pages/insights").then((m) => ({ default: m.InsightsPage })),
);
export const ProMyBlogsPage = lazy(() =>
	import("../pages/blog/my-blogs").then((m) => ({
		default: m.ProMyBlogsPage,
	})),
);
export const NewBlogPage = lazy(() =>
	import("../pages/blog/new").then((m) => ({ default: m.NewBlogPage })),
);
export const EditBlogPage = lazy(() =>
	import("../pages/blog/edit").then((m) => ({ default: m.EditBlogPage })),
);
export const WebsitePage = lazy(() =>
	import("../pages/website").then((m) => ({ default: m.default })),
);
export const SettingsPage = lazy(() =>
	import("../pages/settings").then((m) => ({ default: m.SettingsPage })),
);
export const LeadsPage = lazy(() =>
	import("../pages/leads").then((m) => ({ default: m.LeadsPage })),
);
export const LeadDetailPage = lazy(() =>
	import("../pages/leads/lead-detail").then((m) => ({
		default: m.LeadDetailPage,
	})),
);
export const PipelineInsightsPage = lazy(() =>
	import("../pages/insights/pipeline").then((m) => ({
		default: m.PipelineInsightsPage,
	})),
);
export const PipelineSettingsPage = lazy(() =>
	import("../pages/settings/pipeline").then((m) => ({
		default: m.PipelineSettingsPage,
	})),
);
export const NotificationsPage = lazy(() =>
	import("../pages/notifications").then((m) => ({
		default: m.NotificationsPage,
	})),
);
export const StudioPage = lazy(() =>
	import("../pages/studio/index").then((m) => ({
		default: m.StudioPage,
	})),
);

export const StudioDraftPage = lazy(() =>
	import("../pages/studio/draft").then((m) => ({
		default: m.StudioDraftPage,
	})),
);
export const StudioCreatePage = lazy(() =>
	import("../pages/studio/create").then((m) => ({
		default: m.StudioCreatePage,
	})),
);
export const OnboardingPage = lazy(() =>
	import("../pages/onboarding").then((m) => ({ default: m.OnboardingPage })),
);
export const AcceptTermsPage = lazy(() =>
	import("../pages/accept-terms").then((m) => ({
		default: m.AcceptTermsPage,
	})),
);
export const InternalMetricsPage = lazy(() =>
	import("../pages/InternalMetricsPage").then((m) => ({
		default: m.InternalMetricsPage,
	})),
);
export const SecuritySettingsPage = lazy(() =>
	import("../pages/settings/security").then((m) => ({
		default: m.SecuritySettingsPage,
	})),
);
export const AuthPage = lazy(() =>
	import("../pages/auth").then((m) => ({ default: m.AuthPage })),
);

// ─── Admin Pages ─────────────────────────────────────────────────────────────

export const AdminDashboardPage = lazy(() =>
	import("../pages/admin/dashboard").then((m) => ({
		default: m.AdminDashboardPage,
	})),
);
export const AdminProsPage = lazy(() =>
	import("../pages/admin/pros").then((m) => ({
		default: m.AdminProsPage,
	})),
);
export const AdminBlogListPage = lazy(() =>
	import("../pages/admin/blogs/BlogListPage").then((m) => ({
		default: m.BlogListPage,
	})),
);
export const AdminImportsPage = lazy(() =>
	import("../pages/admin/imports").then((m) => ({
		default: m.AdminImportsPage,
	})),
);
export const AdminImportsNewPage = lazy(() =>
	import("../pages/admin/imports-new").then((m) => ({
		default: m.AdminImportsNewPage,
	})),
);
export const AdminImportsDetailPage = lazy(() =>
	import("../pages/admin/imports-detail").then((m) => ({
		default: m.AdminImportsDetailPage,
	})),
);
export const AdminBlogCreatePage = lazy(() =>
	import("../pages/admin/blogs/create").then((m) => ({
		default: m.AdminBlogCreatePage,
	})),
);
export const AdminBlogEditPage = lazy(() =>
	import("../pages/admin/blogs/edit").then((m) => ({
		default: m.AdminBlogEditPage,
	})),
);
export const AdminBlogCategoriesPage = lazy(() =>
	import("../pages/admin/blogs/categories").then((m) => ({
		default: m.AdminBlogCategoriesPage,
	})),
);
export const AdminBlogSuggestionsPage = lazy(() =>
	import("../pages/admin/blogs/suggestions").then((m) => ({
		default: m.AdminBlogSuggestionsPage,
	})),
);
export const AdminProDetailPage = lazy(() =>
	import("../pages/admin/pro-detail").then((m) => ({
		default: m.AdminProDetailPage,
	})),
);
export const AdminProAnalyticsPage = lazy(() =>
	import("../pages/admin/pro-analytics").then((m) => ({
		default: m.AdminProAnalyticsPage,
	})),
);
export const AdminProCompanyProfilePage = lazy(() =>
	import("../pages/admin/pro-company-profile").then((m) => ({
		default: m.AdminProCompanyProfilePage,
	})),
);
export const AdminProjectsPage = lazy(() =>
	import("../pages/admin/projects").then((m) => ({
		default: m.AdminProjectsPage,
	})),
);
export const AdminProjectDetailPage = lazy(() =>
	import("../pages/admin/project-detail").then((m) => ({
		default: m.AdminProjectDetailPage,
	})),
);
export const AdminUsersPage = lazy(() =>
	import("../pages/admin/users").then((m) => ({
		default: m.AdminUsersPage,
	})),
);
export const AdminUserDetailPage = lazy(() =>
	import("../pages/admin/user-detail").then((m) => ({
		default: m.AdminUserDetailPage,
	})),
);
export const AdminUserSecurityPage = lazy(() =>
	import("../pages/admin/user-security").then((m) => ({
		default: m.AdminUserSecurityPage,
	})),
);
export const AdminTaxonomyPage = lazy(() =>
	import("../pages/admin/taxonomy").then((m) => ({
		default: m.AdminTaxonomyPage,
	})),
);
export const AdminAnalyticsPage = lazy(() =>
	import("../pages/admin/analytics").then((m) => ({
		default: m.AdminAnalyticsPage,
	})),
);
export const AdminCommunicationsPage = lazy(() =>
	import("../pages/admin/communications").then((m) => ({
		default: m.AdminCommunicationsPage,
	})),
);
export const AdminFeedbackPage = lazy(() =>
	import("../pages/admin/feedback").then((m) => ({
		default: m.AdminFeedbackPage,
	})),
);
export const AdminConsultationsPage = lazy(() =>
	import("../pages/admin/consultations").then((m) => ({
		default: m.AdminConsultationsPage,
	})),
);
export const AdminWebLeadsPage = lazy(() =>
	import("../pages/admin/web-leads").then((m) => ({
		default: m.AdminWebLeadsPage,
	})),
);
export const AdminNotificationTestPage = lazy(() =>
	import("../pages/admin/notification-test").then((m) => ({
		default: m.AdminNotificationTestPage,
	})),
);
export const AdminSearchPage = lazy(() =>
	import("../pages/admin/search").then((m) => ({
		default: m.AdminSearchPage,
	})),
);
export const AdminSocialStudioMusicPage = lazy(() =>
	import("../pages/admin/social-studio-music").then((m) => ({
		default: m.AdminSocialStudioMusicPage,
	})),
);
export const AdminSocialStudioTemplatesPage = lazy(() =>
	import("../pages/admin/social-studio-templates").then((m) => ({
		default: m.AdminSocialStudioTemplatesPage,
	})),
);

export const AdminRoomCategoriesPage = lazy(() =>
	import("../pages/admin/room-categories").then((m) => ({
		default: m.AdminRoomCategoriesPage,
	})),
);

export const AdminRoomCategoryDetailPage = lazy(() =>
	import("../pages/admin/room-categories-detail").then((m) => ({
		default: m.AdminRoomCategoryDetailPage,
	})),
);

export const AdminHomePagePage = lazy(() =>
	import("../pages/admin/home-page").then((m) => ({
		default: m.AdminHomePagePage,
	})),
);

export const AdminCalculatorConfigPage = lazy(() =>
	import("../pages/admin/calculator-config").then((m) => ({
		default: m.AdminCalculatorConfigPage,
	})),
);

// ─── Admin WhatsApp Pages ────────────────────────────────────────────────────

export const AdminWhatsAppDashboardPage = lazy(() =>
	import("../pages/admin/whatsapp/index").then((m) => ({
		default: m.WhatsAppDashboardPage,
	})),
);
export const AdminWhatsAppInboxPage = lazy(() =>
	import("../pages/admin/whatsapp/inbox").then((m) => ({
		default: m.WhatsAppInboxPage,
	})),
);
export const AdminWhatsAppTemplatesPage = lazy(() =>
	import("../pages/admin/whatsapp/templates").then((m) => ({
		default: m.WhatsAppTemplatesPage,
	})),
);
export const AdminWhatsAppCampaignsPage = lazy(() =>
	import("../pages/admin/whatsapp/campaigns/index").then((m) => ({
		default: m.WhatsAppCampaignsPage,
	})),
);
export const AdminWhatsAppCampaignCreatePage = lazy(() =>
	import("../pages/admin/whatsapp/campaigns/create").then((m) => ({
		default: m.WhatsAppCampaignCreatePage,
	})),
);
export const AdminWhatsAppCampaignDetailPage = lazy(() =>
	import("../pages/admin/whatsapp/campaigns/$campaignId").then((m) => ({
		default: m.WhatsAppCampaignDetailPage,
	})),
);
export const AdminWhatsAppSendPage = lazy(() =>
	import("../pages/admin/whatsapp/send").then((m) => ({
		default: m.WhatsAppSendPage,
	})),
);
